export default "__VITE_ASSET__f7oZeIWQPQZQSX6yiI5xQw__"